import { GridColumnConfig } from '../../models/gridCoumnConfig';
import { EditableSell } from './editable-cell';
import { NormalCell } from './normal-cell';
import { TypedCell } from './typed-cell';
import { ViewCell } from './view-cell';

export const CustomCellSelector = (
  column: GridColumnConfig,
  otherProps: {
    onView: any;
    customCell?: (field: any) => ((dataItem: any) => JSX.Element) | undefined;
    onEditComplete?: (data: any) => void;
  }
) => {
  if (column.editable) {
    return EditableSell(column, otherProps.onEditComplete);
  }
  if (column.fieldType) {
    return TypedCell(column);
  }
  if (column.navigate) {
    return ViewCell(column, otherProps.onView);
  }
  const customCell = otherProps.customCell?.(column.field);
  if (customCell) {
    return customCell;
  }
  return NormalCell(column);
};
